import { AxiosRequestConfig } from 'axios';
import { TenderType } from 'src/common/enumerations/tender-type';
import { store } from 'src/common/redux/configure-store';
import { POSModeActions } from 'src/common/redux/reducers/pos-mode-reducer';
import { getRefundDue } from 'src/tendering/business-logic/handle-refund-actions';
import { ReturnsType } from 'src/transaction-search/interfaces/get-effective-return-policy-response';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { IRefundTenderGroup } from '../../../common/interfaces/dtos/ITender';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const getPaybackSellableTenders = async (): Promise<IRefundTenderGroup> => {
  const transactionId = store.getState().transaction.transactionId;
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: `/transaction-management/transactions/${transactionId}/refund-tenders`,
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };
  return formatRefundTenders(await emeraldRequest<IRefundTenderGroup>(emeraldRequestParams));
};

export const formatRefundTenders = (refundTenders: IRefundTenderGroup): IRefundTenderGroup => {
  if (!getCurrentXLRConfig().dynamicTender) {
    const validTenders = store.getState().tenderMenu.sellableTenders.rawTenders;
    const isTBRtransaction =
      store.getState().posMode.returnMode.returnType === ReturnsType.TransactionBasedReturn;

    let amountDue = 0;

    if (refundTenders.refundTender?.length) {
      const tenderList = refundTenders.refundTender;
      if (isTBRtransaction && tenderList.length > 1) {
        refundTenders.refundTender.forEach((tender, index) => {
          amountDue += tender.amount ?? 0;
          const refundAmount = tender.amount;
          const tenderWithDetails = validTenders.find(i => i.id === tender.id);
          if (tenderWithDetails) {
            tenderList[index] = tenderWithDetails;
            tenderList[index].amount = refundAmount;
          }
        });
        refundTenders.refundTender = tenderList;
        // store.dispatch(TbrActions.setTBRRecommendedTenderList(tenderList));
      } else {
        const refundTender = tenderList[0];
        const newRefundTender = validTenders.find(tender => tender.id === refundTender.id);
        // we don't take the promotions into account yet for refunds due to a gap in SE. So we send the full refundDue amount to the refundTenders
        const amount = tenderList.length > 1 ? refundTender.amount : getRefundDue(refundTender);
        const refundTenderItem = newRefundTender ? { ...newRefundTender, amount } : refundTender;
        refundTenders.refundTender[0] = refundTenderItem;
      }
    } else {
      refundTenders.refundTender = [];
    }

    if (refundTenders.refundableTenders?.length) {
      const newRefundableTenders = refundTenders.refundableTenders.map(
        tender => validTenders.find(validTender => validTender.id === tender.id) || tender,
      );
      refundTenders.refundableTenders = newRefundableTenders;
    } else {
      refundTenders.refundableTenders = validTenders.filter(
        tender => tender.type !== TenderType.Check,
      );
    }
    isTBRtransaction && store.dispatch(POSModeActions.setTBRRefundDue(amountDue));
  }

  return refundTenders;
};
